<template>
  <div class="search-tabs" v-if="selection">
    <button
      type="button"
      class="search-tab"
      v-on:click="setNewTab(s)"
      :class="{ 'active-type': s.label === selected.label }"
      v-for="s in selection"
    >
      {{ s.label }} ({{ s.numberOfResults }})
    </button>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "SearchTabs",
  computed: {
    ...mapState({
      search: (state) => state.search,
      tabs: (state) => state.search.tabs,
      selected: (state) => state.search.tabs.selected,
      selection: (state) => state.search.tabs.selection,
    }),
  },
  methods: {
    ...mapMutations(["setNewTab"]),
  },
};
</script>

<style scoped>
.search-tabs {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.search-tab {
  margin: 4px 2px;
  padding: 10px 10px;
  cursor: pointer;
  word-break: keep-all;
  white-space: nowrap;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  color: var(--wwfOrange);
  background-color: transparent;
  border-bottom: 1px solid var(--wwfOrange);
}

.active-type {
  background-color: var(--wwfOrange);
  color: var(--wwfWhite);
  border: 1px solid transparent;
}

@media only screen and (max-width: 450px) {
  .search-tab {
    padding: 8px;
    background-color: transparent;
    color: var(--wwfGrey47);
    border: none;
  }

  .active-type {
    border: none;
    border-bottom: 1px solid var(--wwfOrange);
    color: var(--wwfWhite);
    background-color: var(--wwfOrange);
  }
}
</style>


// WEBPACK FOOTER //
// SearchTabs.vue?c2a1b6c0